import { createColumnHelper } from "@tanstack/table-core";
import type { PaymentMethodModel } from "../mobx/core/payment/model.payment";

export const columnHelper = createColumnHelper<PaymentMethodModel>();

export const PaymentMethodColumns = [
  columnHelper.accessor("nickname", {
    id: "nickname",
    header: "Nickname",
  }),
  columnHelper.accessor("type", {
    id: "type",
    header: "Type",
  }),
  columnHelper.accessor("secondaryInfo", {
    id: "secondaryInfo",
    header: "Details",
  }),
  columnHelper.accessor("disabledReason", {
    id: "disabledReason",
    header: "Disabled reason",
    // TODO: if we're goona wrap this text in a badge or something we would do that here
  }),
];
